import { render, staticRenderFns } from "./MediumSmall.vue?vue&type=template&id=ab689da6&scoped=true"
import script from "./MediumSmall.vue?vue&type=script&lang=js"
export * from "./MediumSmall.vue?vue&type=script&lang=js"
import style0 from "./MediumSmall.vue?vue&type=style&index=0&id=ab689da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab689da6",
  null
  
)

export default component.exports